export default __webpack_public_path__ + "./images/ht.b5c599ce.png";